/* eslint-disable react-refresh/only-export-components */

import { BreadCrumbProvider } from "./components/BreadCrumbContext"
import HomePage from "./page/HomePage";
import { Amplify } from 'aws-amplify';
import { Authenticator } from '@aws-amplify/ui-react';
import '@aws-amplify/ui-react/styles.css';
import awsExports from './aws-exports.js';
import { AuthProvider } from "./components/SessionContext";

/**
 *  Configures Amplify library to serve SSO 
 * 
 * @returns {array} The configuration needed for AntDTable
 */
Amplify.configure({...awsExports})

function App() {
  return (
    <Authenticator hideSignUp>
            {({ signOut, user }) => (
      <AuthProvider>        
     <BreadCrumbProvider>
     <HomePage />
      </BreadCrumbProvider>
      </AuthProvider>
      )}
    </Authenticator>
  )
}

export default App;
